import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="page-container" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
      <h1>Page Not Found</h1>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <Link className="button" to="/">Return Home</Link>
    </div>
  );
}

export default NotFound;


